export enum PortalId {
  Body = "body",
  AppSubNav = "#AppLayout__subnav",
}
